import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PublishDate = makeShortcode("PublishDate");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`It is with sadness that I received news of the death of David G. Hutchins on
April 30 in Windhoek,  Namibia. `}</p>
    <p>{`Dave and I go back many years. For both of us our first professional experience,
after gaining our  MScs from the University of Birmingham, was with the
Geological Survey of Botswana in Lobatse.  Dave arrived there a year or two
after me and together we carried out the National Gravity Survey  of the whole
country between August 1972 and December 1973. Between us, there were not  many
hot, dry corners of Botswana that we had not visited by Land Rover by the time
this was  complete. I think we both learned the hard way that being ‘airborne’
was the only way to make  serious progress with geophysical mapping over areas
as large areas as this! `}</p>
    <p>{`Dave stayed on in Lobatse more than ten years after I left, during which time
the first airborne  magnetic coverage of Botswana was completed and many other
geophysical initiatives started  under his leadership. The interpretation of the
pioneering Canadian (CIDA) coverage of the  Kalahari regions benefited greatly
from Dave’s presence in Ottawa while I was working on that for  Terra
Surveys/Geoterrex in 1978. `}</p>
    <p>{`Following his time in Botswana, Dave relocated to Windhoek in Namibia where the
Geological  Survey was starting to find its own way forward as the country
became independent of South  Africa. Clearly the regional geophysical coverage
of an even larger country than Botswana was an  obvious priority and Dave
supervised the resurrection, archiving and publication of pre-existing  data
followed by the instigation of what was to become the most detailed and
ambitious coverage  of magnetic and radiometric survey anywhere in Africa. It
was a privilege for me to review this on  behalf of the EU during two long
missions to Namibia in 1999 and 2000. Once again, it was  evident that Dave’s
input was instrumental in moving this forward and giving geophysical mapping
the central role it deserves in any country where geological exposure is
limited. `}</p>
    <p>{`Not least, Dave made sure that Namibia was always well represented at the
important  international conventions where the mineral exploration community
gathers. He helped establish  Namibia as a destination for investment in mineral
exploration amongst the most attractive in  Africa, at least as far as
geophysics could contribute. He was also keen to promote the training and  sound
career paths of young African earth scientists in Namibia and within his own
organisation. At  an organisational level I always found it impressive the way
in which his powers of persuasion,  perseverance and patience made things happen
in Namibia in a way that is, sadly, not at all typical  of government
bureaucracies elsewhere in Africa. Dave spent more than 25 years in this role,
mapping Namibia and putting Namibia on the map. Together with his time in
Botswana, he has  made a career-long contribution to the exploration of southern
Africa that deserves singular  recognition. At the same time, he made a lot of
friends as he was nothing if not sociable and  unassuming as a colleague. He
will be greatly missed. `}</p>
    <p>{`I extend my deepest sympathies to his wife Pat and his daughter Desiree. `}</p>
    <p>{`Colin Reeves `}</p>
    <PublishDate mdxType="PublishDate" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      